export const IPIRegex = /^[0-9]{1,11}$/;
export const IPNRegex = /^[0-9]{9}$/;
export const ISNIRegex = /^[0-9]{1,16}$|^[0-9]{1,15}[Xx]$/;
